/**
 * Used to provide a static link for related document
 */
export const documentLinks = {
  termsAndConditions:
    "https://www.wartsila.com/docs/default-source/default-document-library/general-terms-and-conditions-parts-2025.pdf?sfvrsn=8935ec45_55",
  termsAndConditionsServices:
    "https://www.wartsila.com/docs/default-source/default-document-library/general-terms-and-conditions-services-2025.pdf",
  specificClauses: "https://wartsila.my.site.com/online/resource/1525869731000/Agree_with_specific_clauses",
};
